export default __webpack_public_path__ + "static/media/red-darken-seasonal.85e6c9c9.svg";